<template>
	<div>
		 <!-- breadcrumb area -->
		 <div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		     <div class="container">
		         <div class="breadcrumb-content text-center">
		             <h2>搜索结果</h2>
		         </div>
		     </div>
		 </div>
		 
		 <div class="section">
			<div class="container search-div">
				<Input v-model="keyword" size="large" @on-enter="UserSearchList" placeholder="请输入搜索内容" />
				<Button style="margin-left: 10px;height: 40px;" type="success" @click="UserSearchList">搜索</Button>
			</div>
		 </div>
		 
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
					<button v-for="(item,index) in meun" :key="index" :class="cateIndex==item.id?'active':''" class="btn-project" data-filter="*" @click="clickCate(item.id)">{{item.name}}</button>
		        </div>
		        <div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
		            <div class="col mb-6 grid-item cat2 cat4" v-for="(item,index) in projectList" :key="item.id">
		                <div class="project-wrap">
		                    <div class="project-inner">
		                        <a @click="toDetail(item)" class="thumbnail">
		                            <img :src="item.image | imgfilter" alt="Blog Image" style="height: 370px;object-fit: cover;">
		                        </a>
								<div class="project-content d-flex">
									<div style="flex: 1;">
										<div style="font-size: 18px;">
											<div @click="toDetail(item)">{{item.name}}</div>
										</div>
										<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
									</div>
								</div>
		                    </div>
		                </div>
		            </div>
		        </div>
		        <div class="pagination-style mt-6 mt-md-8 mt-lg-10">
		            <div class="block">
		                <el-pagination
		                  @current-change="handleCurrentChange"
		            	  :pager-count="5"
		                  :current-page="currentPage"
		                  layout="total, prev, pager, next"
		                  :total="total">
		                </el-pagination>
		              </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		UserSearchList,
	 } from '@/api'
	 export default {
	   data() {
			return {
				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				projectList: [],
				keyword:'',
				meun: [{
					id: 1,
					name: '案例'
				},
				{
					id: 3,
					name: '公司'
				},
				{
					id: 2,
					name: '产品'
				},
				{
					id: 4,
					name: '展厅'
				},
				{
					id: 5,
					name: '展会'
				}],
				cateIndex: 1,
				
				currentPage: 1,
				total: 0
			}
		},
		created() {
			if(this.$route.query.keyword) {
				this.keyword = this.$route.query.keyword
				this.cateIndex = parseInt(this.$route.query.stype) || 1
			}
		    this.UserSearchList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			
			toDetail(item) {
				switch (this.cateIndex){
					case 1:
						let routeUrl = this.$router.resolve({
							path: '/projectDetail/'+item.id,
						  })
						  window.open(routeUrl.href, '_blank')
						break;
					case 2:
						let routeUrl2 = this.$router.resolve({
							path: '/productDetail/'+item.id,
						  })
						  window.open(routeUrl2.href, '_blank')
						break;
					case 3:
						let routeUrl3 = this.$router.resolve({
							path: '/merchantDetail/'+item.zk_id,
						  })
						  window.open(routeUrl3.href, '_blank')
						break;	
					case 4:
						let routeUrl4 = this.$router.resolve({
							path: '/showDetail/'+item.id,
						  })
						  window.open(routeUrl4.href, '_blank')
						break;
					case 5:
						let routeUrl5 = this.$router.resolve({
							path: '/exhibitionDetail/'+item.id,
						  })
						  window.open(routeUrl5.href, '_blank')
						break;			
					default:
						break;
				}
			},
			
			clickCate(id) {
				this.cateIndex = id
				this.UserSearchList()
			},
			
			// 页数跳转
			handleCurrentChange(val) {
				this.currentPage = val
				this.UserSearchList()
				document.documentElement.scrollTop= 0
			},
			
			// 获取展厅详情
			UserSearchList() {
			  UserSearchList({
				  keyword: this.keyword,
				  limit: 10,
				  page: this.currentPage,
				  stype: this.cateIndex,
			  }).then(res => {
				  let data = res.data
				  data.list.forEach(e => {
					  if(e.tags) {
					  	e.tags = e.tags.split(',') || []
					  }
				  }) 
				  this.total = data.count
				  this.projectList = data.list
			  })
			},
		}
	}
</script>

<style>
</style>
